import type { TSession, TSessionBase } from "@/types/activities"

export function isStarted(session: TSession) {
  return Date.now() >= session.dtstart
}

const STATES_OVER: TSession["state"][] = ["canceled", "finished", "declined"]

export function isOver(session: TSessionBase) {
  return Date.now() >= session.dtfinish || STATES_OVER.includes(session.state)
}

export function isEditable(session: TSession) {
  return isStarted(session) && !isOver(session)
}
